"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AddCustomerModal_1 = __importDefault(require("./AddCustomerModal"));
exports.default = AddCustomerModal_1.default;
